import React from 'react';

const CHAMP_TIRET = '—';

/**
 * Compétences ou langues du profil enrichi en pastilles « nom · niveau »,
 * en lecture seule (YRH-NEW-008, Yros/Kavero#479). Un tiret si la liste est vide.
 */
function PastillesCompetences({ lignes, testid }) {
  return (
    <div data-testid={testid} className="flex flex-wrap gap-1.5">
      {lignes && lignes.length ? (
        lignes.map((ligne) => (
          <span
            key={ligne.skill_id}
            className="px-2.5 py-1 rounded-full bg-slate-100 text-slate-700 text-xs font-medium"
          >
            {`${ligne.competence} · ${ligne.niveau}`}
          </span>
        ))
      ) : (
        <span className="text-xs sm:text-sm text-slate-400">{CHAMP_TIRET}</span>
      )}
    </div>
  );
}

export default PastillesCompetences;
